import { Component, OnInit, inject, ChangeDetectionStrategy, signal } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle} from '@angular/material/dialog';
import {MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTable, MatTableDataSource} from '@angular/material/table';
import {Entity} from '../../entity/entity';
import {EntitySearchCriteria} from '../../entity/entity-search-criteria';
import {SelectParentEntityDialogService} from '../../services/select-parent-entity-dialog-service';
import {EntityHeader} from '../../entity/entity-header';
import {EntityKey} from '../../entity/entity-key';
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {MatFormField} from '@angular/material/form-field';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import { CurrencyPipe, DatePipe } from '@angular/common';


@Component({
    selector: 'select-parent-entity-dialog',
    templateUrl: './select-parent-entity-dialog.component.html',
    styleUrls: ['./select-parent-entity-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatProgressSpinner, MatDialogTitle, MatDialogContent, MatFormField, MatInput, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatDialogClose, CurrencyPipe, DatePipe]
})

export class SelectParentEntityDialogComponent implements OnInit {
  private readonly service = inject(SelectParentEntityDialogService);
  private readonly dialogRef = inject<MatDialogRef<SelectParentEntityDialogComponent>>(MatDialogRef);
  private readonly data = inject<Entity>(MAT_DIALOG_DATA);

  readonly isBusy = signal<boolean>(true);
  readonly errorMessage = signal<string>(undefined!);
  successMessage!: string;
  results!: MatTableDataSource<EntityHeader>;
  readonly selectedEntity = signal<EntityHeader>(undefined!);
  displayedColumns: string[] = ['entity-id', 'project-name', 'unit-qty', 'total-cost', 'updated-date'];
  searchCriteria: EntitySearchCriteria = new EntitySearchCriteria;

  ngOnInit(): void {
    this.isBusy.set(true);
    this.searchCriteria.entityName = this.data.id.entityName;
    this.searchCriteria.orgUnitId = this.data.repOfficeId;
    this.getQuotes();
  }

  getQuotes() {
    this.isBusy.set(true);
    this.service.getList(this.searchCriteria).subscribe({
      next: response => {
        this.results = new MatTableDataSource<EntityHeader>();
        this.results.data.push(this.buildNoParentEntityHeader());
        this.selectedEntity.set(response.find(header =>
          this.data.id.entityId === header.id.entityId &&
          this.data.id.entityRevision.toString() === header.id.entityRevision
        ) || null!);
        this.results.data.push(...response.filter(header => {
          return header.sellingOrgUnitID === this.data.repOfficeId
            && !(header.id.entityId == this.data.id.entityId && header.id.entityRevision == this.data.id.entityRevision.toString())
            && !['PTS', 'WAR'].includes(header.priorityCode)
            && header.approvalStatus == 'Pending Release'
        }));
        this.results.filterPredicate = (header: EntityHeader, filter: string): boolean => {
          let displayedEntityId: string = header.id.entityId + ";" + header.id.entityRevision;
          if (displayedEntityId.includes(filter)) return true;
          if (header.projectName.includes(filter)) return true;
          return false;
        };
        this.isBusy.set(false);
      },
      error: error => {
        this.handleError(error)
      },
    })
  }

  private buildNoParentEntityHeader(): EntityHeader {
    let noParentEntity = new EntityHeader();
    noParentEntity.id = new EntityKey;
    noParentEntity.id.entityId = 'QT00000000';
    noParentEntity.id.entityRevision = '0';
    noParentEntity.sellingOrgUnitID = this.data.repOfficeId;
    noParentEntity.id.entityType = this.data.id.entityName;
    noParentEntity.projectName = 'No Parent Entity';
    noParentEntity.totalUnitQty = 0;
    noParentEntity.finalExtendedAmount = 0;
    noParentEntity.updateTimestamp = new Date().toISOString();
    return noParentEntity;
  }

  public saveAndClose(): void {
    this.dialogRef.close(this.selectedEntity().id);
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  cindex!: number

  rowClicked(entity: EntityHeader, index: number) {
    this.selectedEntity.set(entity);
    this.cindex = index;
  }

  applyFilter(target: any) {
    this.results.filter = target.value;
  }

  private handleError(error: any): void {
    this.isBusy.set(false);
    this.errorMessage.set(error.message);
  }

}
